<template>
    <div class="container">
        <div class="width" style="margin-top:30px">
            <el-row :gutter="20">
                <el-col
                    v-for="(item, index) in brandList"
                    :key="index"
                    :span="4"
                    style="padding:10px 18px"
                    v-show="item.images"
                >
                    <img :src="item.images" :alt="item.name" width="100%" height="65px" />
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';

export default {
    name: 'Brand',
    data() {
        return { brandList: [] };
    },
    methods: {
        getBrandList() {
            apis.getBrandList({}).then(res => {
                this.brandList = res.data;
            });
        },
    },
    mounted() {
        this.getBrandList();
    },
};
</script>
<style scoped>
img {
    border: 1px solid #e8e8e8;
}
</style>
